import { contactInfo } from '@/mocks/baoliao';

export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              {contactInfo.title}
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
              有猛料？我们时刻准备好接你的瓜
            </p>
          </div>

          <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8">
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              {contactInfo.description}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              <div className="flex items-center gap-3 p-4 rounded-md bg-background-100 border border-background-200/50">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-mail-line text-primary-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-500">投稿邮箱</div>
                  <div className="text-sm font-medium text-foreground-900">{contactInfo.email}</div>
                </div>
              </div>
              <div className="flex items-center gap-3 p-4 rounded-md bg-background-100 border border-background-200/50">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-phone-line text-accent-600 text-lg"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-500">咨询热线</div>
                  <div className="text-sm font-medium text-foreground-900">{contactInfo.phone}</div>
                </div>
              </div>
            </div>

            <div className="space-y-2">
              {contactInfo.tips.map((tip, idx) => (
                <div key={idx} className="flex items-start gap-2 text-sm text-foreground-600">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                  <span>{tip}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}